module.exports = __webpack_public_path__ + "static/img/earrings_02.88d8e84.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/accessories/thumbnail/earrings_02.png
// module id = rczQ
// module chunks = 0